// src/Features/Projects/pages/ProjectCreate/ProjectCreate.tsx
import { useNavigate } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { ProjectCreateForm } from "@/features/Projects";

export default function ProjectCreate() {
  const navigate = useNavigate();

  const handleSuccess = (projectId: string) => {
    // Navegar para a página do projeto criado
    navigate(`/projects/${projectId}`);
  };

  const handleCancel = () => {
    navigate("/projects");
  };

  const handleGoBack = () => {
    navigate("/projects");
  };

  return (
    <div className="max-w-6xl mx-auto space-y-6">
      {/* Breadcrumb/Navigation */}
      <div className="flex items-center space-x-4">
        <button
          onClick={handleGoBack}
          className="flex items-center space-x-2 text-raro-gray-600 hover:text-primary-600 transition-colors"
        >
          <ArrowLeftIcon className="w-5 h-5" />
          <span className="font-medium font-montserrat">
            Voltar aos Projetos
          </span>
        </button>
      </div>

      {/* Form */}
      <ProjectCreateForm onSuccess={handleSuccess} onCancel={handleCancel} />

      {/* Tips Section */}
      <div className="bg-gradient-to-br from-primary-50 to-primary-100/50 rounded-2xl p-8 border border-primary-200">
        <h3 className="text-lg font-semibold text-primary-900 font-montserrat mb-4">
          💡 Dicas para uma boa descrição
        </h3>

        <div className="grid md:grid-cols-2 gap-6">
          <div>
            <h4 className="font-medium text-primary-800 mb-2">
              O que incluir:
            </h4>
            <ul className="space-y-2 text-sm text-primary-700">
              <li className="flex items-start space-x-2">
                <span className="text-green-600 mt-0.5">✓</span>
                <span>Problema que o projeto resolve</span>
              </li>
              <li className="flex items-start space-x-2">
                <span className="text-green-600 mt-0.5">✓</span>
                <span>Público-alvo ou usuários</span>
              </li>
              <li className="flex items-start space-x-2">
                <span className="text-green-600 mt-0.5">✓</span>
                <span>Funcionalidades principais desejadas</span>
              </li>
              <li className="flex items-start space-x-2">
                <span className="text-green-600 mt-0.5">✓</span>
                <span>Plataforma (web, mobile, desktop)</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-primary-800 mb-2">Exemplo:</h4>
            <div className="bg-white/80 rounded-lg p-4 text-sm text-raro-gray-700 border border-primary-200">
              <p className="italic">
                "Preciso de um sistema de gestão para minha clínica veterinária.
                Deve permitir cadastro de pets e proprietários, agendamento de
                consultas, histórico médico dos animais e controle financeiro.
                Será usado por 3 veterinários e 2 recepcionistas. Preciso que
                seja web, responsivo e integre com WhatsApp para lembretes."
              </p>
            </div>
          </div>
        </div>

        <div className="mt-6 p-4 bg-primary-200/50 rounded-lg border border-primary-300">
          <p className="text-sm text-primary-800">
            <strong>💡 Pro tip:</strong> Quanto mais detalhada for sua descrição
            inicial, melhor será o resultado da expansão com IA. A inteligência
            artificial irá identificar requisitos, sugerir funcionalidades e
            estruturar seu projeto.
          </p>
        </div>
      </div>
    </div>
  );
}
